<template>
  <div class="shortcuts-container">
    <div class="periods-container">
      <button
        v-for="(shortcut, i) in shortcuts"
        :key="i"
        class="mx-btn mx-btn-text"
        @click="selectPeriod(emit, shortcut)"
      >
        {{ shortcut.label }}
      </button>
    </div>
  </div>
</template>

<script>
import { buildPresetRail, resolvePreset } from "@/lib/datePresets";

export default {
  props: {
    emit: {
      type: Function,
      default: null
    },
    periods: {
      type: Array,
      default: () => ["current", "previous"]
    }
  },
  data() {
    return {
      shortcuts: []
    };
  },
  created() {
    this.shortcuts = buildPresetRail(this.periods);
  },
  methods: {
    selectPeriod(emit, shortcut) {
      emit(resolvePreset(shortcut));
    }
  }
};
</script>

<style lang="scss" scoped>
.periods-container {
  display: flex;
  flex-direction: column;
}

.shortcuts-container {
  display: flex;
  flex-direction: column;
}
</style>
